import React from 'react';
import {User} from "types/User";
import DescriptionList from "components/DescriptionList";
import DescriptionListItem from "components/DescriptionListItem";
import DescriptionTerm from "components/DescriptionTerm";
import DescriptionDetails from "components/DescriptionDetails";
import Link from "components/Link";
import {toTitleCase} from "services/string";
import Card from "components/Card";

// Types ----

type ProfileCardProps = {
  audienceMember?: User
  isLoading?: boolean
};

// Component ----

function ProfileCard({audienceMember, isLoading}: ProfileCardProps) {
  return (
    <Card heading="Member" isLoading={isLoading}>
      <DescriptionList>
        <DescriptionListItem span={1}>
          <DescriptionTerm>Name</DescriptionTerm>
          <DescriptionDetails>
            {audienceMember?.name}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Email</DescriptionTerm>
          <DescriptionDetails>
            <Link to={`mailto:${audienceMember?.email}`}>{audienceMember?.email}</Link>
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Gender</DescriptionTerm>
          <DescriptionDetails>
            {toTitleCase(audienceMember?.gender ?? 'Unknown')}
          </DescriptionDetails>
        </DescriptionListItem>

        <DescriptionListItem span={1}>
          <DescriptionTerm>Age</DescriptionTerm>
          <DescriptionDetails>
            {audienceMember?.age ? `${audienceMember?.age} years` : 'Unknown'}
          </DescriptionDetails>
        </DescriptionListItem>
      </DescriptionList>
    </Card>
  );
}

// Export ----

export default ProfileCard;